import { Col, Container, Navbar, Row } from "reactstrap";
import { PiBellRingingLight } from "react-icons/pi";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from '../../context';
import { LuLogOut } from "react-icons/lu";
import { API_URL } from "../../utils/constants";
import DefaultButton from "../Buttons/Default";
import { useTranslation } from "react-i18next";
import i18n from 'i18next';
import './Header.css';

function Header() {
  const { isLoggedIn, handleLogout } = useAuth();
  const { t } = useTranslation('header');
  const navigate = useNavigate();

  const logout = async () => {
    try {
      const response = await fetch(API_URL + '/logout', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        localStorage.removeItem('token');
        handleLogout();
        navigate('/');
        return;
      }

      const data = await response.json();
      if (data && data.success) {
        localStorage.removeItem('token');
        handleLogout();
        navigate('/');
      }
    } catch (err) {
      localStorage.removeItem('token');
      handleLogout();
      navigate('/');
    }
  };

  const handleAddClick = () => {
    if(isLoggedIn) {
      navigate('/my_properties/create');
    } else {
      navigate('/login');
    }
  };

  const changeLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLang);
  }

  return (
    <Navbar fixed="top" className="shadow-sm bg-white">
      <Container>
        <Row className="align-items-center">
          <Col lg="2" md="3" xs="6">
            <Link to={'/'}>
              <img src={ require('../../assets/images/logo.png') } alt="Logo" height={55} />
            </Link>
          </Col>
          <Col lg="7" md="6" className="d-md-block d-none">
            <nav className="d-flex gap-4 align-items-center">
              <Link to="/" className={`text-dark ${window.location.pathname === '/' ? 'active' : ''}`}>
                { t('home') }
              </Link>
              <Link to="/offices" className={`text-dark ${window.location.pathname === '/offices' ? 'active' : ''}`}>
                { t('offices') }
              </Link>
              <Link to="/plans" className={`text-dark ${window.location.pathname === '/plans' ? 'active' : ''}`}>
                { t('plans') }
              </Link>
              <Link to="/profile" className={`text-dark ${window.location.pathname === '/profile' ? 'active' : ''}`}>
                { t('account') }
              </Link>
              <Link onClick={changeLanguage} className={`text-dark`}>
                { i18n.language === 'en' ? 'عربي' : 'EN' }
              </Link>

              <DefaultButton outline onClick={handleAddClick}>
                + { t('new_ad') }
              </DefaultButton>
            </nav>
          </Col>
          <Col lg="3" md="3" xs="6" className="d-flex align-items-center justify-content-end">
            <Link to="/notifications" className="text-dark">
              <PiBellRingingLight size={28} />
            </Link>

            {isLoggedIn &&
              <LuLogOut 
                className='text-danger ms-3 cursor-pointer' 
                size={24} 
                onClick={logout}
              />
            }
          </Col>
        </Row>
      </Container>
    </Navbar>
  );
}

export default Header;